import { apiService } from "../../../../services/apiService";
import { apiServiceConstants } from "../../../../constants";
import { utilService } from "../../../../services/utilService";
import {
  availabListParams,
  Data,
  DataOfDays,
  Fri,
  Mon,
  RespAvailabListInterface,
  RespAvailabListModel,
  Sat,
  Sun,
  Thu,
  Tue,
  Wed,
} from "./Models/AvailabilityList.model";
import {
  availabListCardParams,
  RespAvailabListCardInterface,
  RespAvailabListCardModel,
} from "./Models/Components/AvailabilityListCard/Models/AvailabilityListCard.model";
import {
  availabListEditParams,
  RespAvailaListEditModel,
} from "./Models/Components/AvailabilityListCard/Components/AvailabListEdit/Models/AvailabListEdit.model";
import { Subject } from "rxjs";

let refreshAvailabList = new Subject<any>();

const getAvailabilityList = async (
  params: availabListParams
): Promise<RespAvailabListInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/template-availability/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const availabListResp = res as RespAvailabListModel;
      const availabListResponse = setAvalabListModel(availabListResp);
      const result: RespAvailabListInterface = {
        isSuccess: availabListResp.isSuccess,
        displayAvailabListContainer: availabListResponse,
        status: availabListResp.status,
        message: availabListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespAvailabListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayAvailabListContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const removeAvailabilityList = async (
  params: availabListCardParams
): Promise<RespAvailabListCardInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/template-availability/?reg_code=${utilService.getNetwork()}&guid=${params.guid}&page=${params.page}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const availabListCardResp = res as RespAvailabListCardModel;
      const availabListCardResponse = setAvalabListModel(availabListCardResp);
      const result: RespAvailabListCardInterface = {
        isSuccess: availabListCardResp.isSuccess,
        displayAvailabListCardContainer: availabListCardResponse,
        status: availabListCardResp.status,
        message: availabListCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespAvailabListCardInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayAvailabListCardContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const setAvalabListModel = (payload: RespAvailabListModel): any => {
  let AvailabListArray = payload.result?.map((object: any) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: mapData(object.data),
    };
  });

  return AvailabListArray;
};

const mapData = (groupData: Array<Data>): any => {
  let DataListArray = groupData.map((object: any) => {
    return {
      id: object.id,
      editable: object.editable,
      startDate: object.start_date,
      endDate: object.end_date,
      data: mapDataOfDays(object.data),
    };
  });

  return DataListArray;
};

const mapDataOfDays = (data: DataOfDays): any => {
  var userDataObject = {
    sun: mapDataOfSun(data.sun),
    mon: mapDataOfMon(data.mon),
    tue: mapDataOfTue(data.tue),
    wed: mapDataOfWed(data.wed),
    thu: mapDataOfThurs(data.thu),
    fri: mapDataOfFri(data.fri),
    sat: mapDataOfSat(data.sat),
  };
  return userDataObject;
};

const mapDataOfSun = (data: Sun): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfMon = (data: Mon): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfTue = (data: Tue): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfWed = (data: Wed): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfThurs = (data: Thu): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfFri = (data: Fri): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};
const mapDataOfSat = (data: Sat): any => {
  var userDataObject = {
    id: data.id,
    startTime: data.start_time,
    endTime: data.end_time,
    active: data.active,
  };
  return userDataObject;
};

const submitAvailabilityList = async (
  params: availabListEditParams
): Promise<RespAvailaListEditModel> => {
  const respApiResult = await apiService
    .apiCall(
      `user/template-availability/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const availabListEditResp = res as RespAvailaListEditModel;
      const availabListEditResponse = setAvalabListModel(availabListEditResp);
      const result: RespAvailaListEditModel = {
        isSuccess: availabListEditResp.isSuccess,
        result: availabListEditResponse,
        status: availabListEditResp.status,
        message: availabListEditResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespAvailaListEditModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        result: [],
      };
      return result;
    });

  return respApiResult;
};

const reloadAvailabListData = () => {
  refreshAvailabList.next(true);
};

const handleErrorResponse = () => {};

export const availabListService = {
  getAvailabilityList,
  removeAvailabilityList,
  submitAvailabilityList,
  handleErrorResponse,
  reloadAvailabListData,
  refreshAvailabList,
};
